import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const StandardEquipmentModalStyles = ({ theme }: DefaultThemeProps) => css`
	margin: ${pxToRem(theme.spacing['500'])} 0;
`;

export const StandardEquipmentModalContainer = styled.div`
	${StandardEquipmentModalStyles}
`;
